var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('logo'),_c('top-menu',{key:Math.random(),attrs:{"regStat":_vm.registrationLink}}),_c('router-view',{key:_vm.$route.path}),_c('partner'),_c('big-footer'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }